/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "./SmoothScroll";
import { Helmet } from "react-helmet-async";
const TermsOfUse = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | Citrus Diagnostic Center | Florida</title>
        <meta
          name="description"
          content="Review terms and conditions for using the Citrus Diagnostic Center website, including medical disclaimers, user responsibilities, and limitations of liability."
        />
        <meta
          name="keywords"
          content="medical disclaimer
terms and conditions
"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 text-white">
        <div className="lg:w-[90%] w-[95%] mx-auto  flex flex-col items-center  pb-8 lg:pb-16">
          <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 mb-4 text-center capitalize w-full">
            {" "}
            Terms & Conditions
          </h1>
          <div className="text-left">
            <h2 className="lg:text-[32px] lg:text-left text-center text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize">
              Citrus Diagnostic Center
            </h2>
            <p className="text-[#cccccc] mt-5 text-[17px] lg:text-left text-center leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-8 font-robout">
              Effective Date: January 1, 2026
            </p>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 p-4 text-left font-robout">
              These Terms & Conditions govern your use of the Citrus Diagnostic
              Center website and any related online services. By accessing or
              using this website, you agree to these Terms & Conditions. If you
              do not agree, please do not use this website.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Website Use
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              The content on this website is provided for{" "}
              <span className="font-extrabold">
                general informational purposes
              </span>{" "}
              only. It is not intended to replace medical advice, diagnosis, or
              treatment provided by a qualified healthcare professional.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Use of this website does{" "}
              <span className="font-extrabold">not</span> establish a
              physician-patient relationship with Citrus Diagnostic Center or
              its radiologists.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Medical Disclaimer
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Information on this website should not be used to make medical
              decisions or delay seeking professional care. Imaging studies and
              medical recommendations are provided only after proper referral,
              clinical review, and direct patient interaction.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Scheduling & Online Requests
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Online appointment requests, forms, or inquiries are{" "}
              <span className="font-extrabold"> not guarantees of service</span>
              . All appointments are subject to confirmation by Citrus
              Diagnostic Center staff and clinical appropriateness.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Patient & Provider Portals
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              This website may provide access or links to secure patient and
              provider portals operated by third-party vendors. Use of those
              portals is governed by the applicable vendor terms and privacy
              policies.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Citrus Diagnostic Center is not responsible for interruptions,
              technical issues, or outages related to third-party platforms.
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Third-Party Links
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              This website may contain links to external websites for
              convenience or informational purposes. Citrus Diagnostic Center
              does not control, endorse, or assume responsibility for the
              content or practices of those websites.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Intellectual Property
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              All content on this website, including text, images, logos, and
              design elements, is the property of Citrus Diagnostic Center or
              its licensors and is protected by applicable copyright and
              trademark laws.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Content may be viewed or downloaded for{" "}
              <span className="font-extrabold">
                {" "}
                personal, non-commercial use only
              </span>
              .
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Limitation of Liability
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              To the fullest extent permitted by law, Citrus Diagnostic Center
              is not liable for any damages arising from the use of, or
              inability to use, this website, including but not limited to
              indirect, incidental, or consequential damages.
            </p>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              These limitations apply{" "}
              <span className="font-extrabold">only to website use</span> and do
              not affect patient rights related to medical care.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Privacy
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] font-normal lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Use of this website is also governed by our{" "}
              <span className="font-extrabold">Privacy Policy</span> and
              <span className="font-extrabold">
                {" "}
                Notice of Privacy Practices
              </span>
              , which describe how personal and health information is handled.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Changes to These Terms
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Citrus Diagnostic Center may update these Terms & Conditions
              periodically. Updates will be posted on this page with a revised
              effective date.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Governing Law
            </h2>
            <p className="text-[#cccccc] text-[17px] leading-[1.4em] lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              These Terms & Conditions are governed by the laws of the{" "}
              <span className="font-extrabold"> State of Florida </span> ,
              without regard to conflict-of-law principles.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 lg:pt-10 pb-5">
              Contact Information
            </h2>

            <h2 className="text-[17px]  text-[#cccccc] lg:ps-0 md:px-8 px-4 pb-5">
              If you have questions regarding these Terms & Conditions, please
              contact:
            </h2>
            <p className="text-[#cccccc] font-normal  text-[24px] leading-[1.4em]  lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Citrus Diagnostic Center
            </p>
            <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col mt-2 gap-3 text-[#ccc] font-normal lg:ps-0 md:px-8 px-4 pb-8  text-left font-robout">
              <li>
                <span className="">Phone : </span>{" "}
                <a href="tel:352-795-9200" className="hover:underline">
                  {" "}
                  352-795-9200
                </a>
              </li>
              <li>
                <span className="">Fax : </span>{" "}
                <a href="tel:352-795-6460" className="hover:underline">
                  {" "}
                  352-795-6460
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
